import Container from './TierBatchEdit.container';
import TierBatchEdit from './TierBatchEdit';

export default Container(TierBatchEdit);
